import SubcategoryPage from '@/components/template/SubcategoryPage';

const MilordPortaAsciugamani = () => {
  const products = [
    {
      title: "Milord Porta Asciugamani Classic",
      imageSrc: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80",
      url: "/proizvodi/milord-porta-asciugamani-classic"
    },
    {
      title: "Milord Porta Asciugamani Modern",
      imageSrc: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/milord-porta-asciugamani-modern"
    },
    {
      title: "Milord Porta Asciugamani Luxury",
      imageSrc: "https://images.unsplash.com/photo-1599638075338-c400e736d58b?auto=format&fit=crop&q=80",
      url: "/proizvodi/milord-porta-asciugamani-luxury"
    }
  ];

  return (
    <SubcategoryPage
      title="Milord Porta Asciugamani"
      description="Elegantni italijanski stojala za brisače, ki združujejo estetiko in funkcionalnost za vašo kopalnico."
      heroImage="https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default MilordPortaAsciugamani;